import { Controller } from "remult";

@Controller("team-opportunity-methods")
export class TeamOpportunityMethods {}
